import { render, staticRenderFns } from "./PoliticaAlcoholDrogasPagination.vue?vue&type=template&id=7f22fae3&"
import script from "./PoliticaAlcoholDrogasPagination.vue?vue&type=script&lang=js&"
export * from "./PoliticaAlcoholDrogasPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports